import { Button } from "@/components/ui/button";
import type { ReactNode } from "react";
import { useDropzone } from "react-dropzone";
import { Upload } from "lucide-react";

interface DragAndDropFileUploaderProps {
  title: string;
  icon: ReactNode;
  className?: string;
  onChange: (files: File[]) => void;
}

export const DragAndDropFileUploader = ({ icon, title, onChange, className }: DragAndDropFileUploaderProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      onChange(acceptedFiles);
    },
  });

  return (
    <div
      {...getRootProps()}
      className={`cursor-pointer rounded-xl border-2 border-dashed bg-white py-4 text-center ${className} ${isDragActive ? "border-black bg-gray-100" : "border-gray-300"}`}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center gap-2">
        {icon}
        <p className="text-[14px] font-medium text-gray-800">{title}</p>
        <div className="mt-3 mr-3 ml-3">
          <Button className="!h-7 w-full !bg-[#000] text-white" variant="default" size="lg">
            <Upload className="h-4 w-4" />
            <p className="!text-[14px]">Browse</p>
          </Button>
        </div>
        <p className="mt-2 !text-xs text-gray-500">Drag and drop to upload, or click the upload buttons</p>
      </div>
    </div>
  );
};
